export enum SnowflakeLauncherModalState {
    INACTIVE = 'INACTIVE',
    IN_PROGRESS = 'IN_PROGRESS',
    PROVISIONING_SUCCESS = 'PROVISIONING_SUCCESS',
    REDIRECT_FAILED = 'REDIRECT_FAILED',
    PROVISIONING_FAILED = 'PROVISIONING_FAILED',
}
